import React from 'react';

import { IBlockRuleKeyValueBuilder } from '@components/block-event-single/components/BlockRuleKeyValueBuilder/typed';
import {
  EBlockEventSingleChangeType,
  scaledBlockRuleTagKeyOptions,
} from '@components/block-event-single/constant/constant';
import { EPanelOpenMethod } from '@components/block-event-single/store';
import { AutoCompleteInput } from '@components/common/AutoCompleteInput';
import { buildOptionsWithTag } from '@components/common/AutoCompleteInput/buildOptionsWithTag';
import { useQueryDimensionData } from '@components/mapping-panel/api';
import { blockEventSingleOperatorOptions } from '@components/mapping-panel/components/RuleBuilder/KeyValueBuilder/typed';
import { createFiltersGroup } from '@components/mapping-panel/utils/createFiltersUtils';
import { mappedEventDimensionType } from '@src/common/constant/enum';

import { OperatorSelect, StyledAutoComplete } from './styled';

const BlockRuleKeyValueBuilder: React.FC<IBlockRuleKeyValueBuilder> = ({
  mode,
  eventName,
  data,
  blockRules,
  onChange,
}) => {
  const { data: tagValueData, isFetching: isTagValueLoading } = useQueryDimensionData(
    {
      fields: [mappedEventDimensionType.merged_event_tag_value],
      filters: createFiltersGroup(eventName, data?.key),
    },
    500,
  );
  const blockRuleValue = data?.value?.join();

  const currentBlockRule = blockRules ? blockRules[0]?.map((x) => x.value?.toString()) : [];
  const blockRuleValueOptions = buildOptionsWithTag(
    tagValueData ?? [],
    mappedEventDimensionType.merged_event_tag_value,
    blockRuleValue,
    undefined,
    undefined,
    false,
    false,
    undefined,
    currentBlockRule,
  );

  return (
    <>
      <StyledAutoComplete
        placeholder="Type or select..."
        defaultValue={scaledBlockRuleTagKeyOptions[0].value}
        value={data?.key}
        options={scaledBlockRuleTagKeyOptions}
        disabled
        showArrow={false}
        bordered={false}
      />
      <OperatorSelect
        disabled={mode === EPanelOpenMethod.VIEW}
        defaultValue={blockEventSingleOperatorOptions?.[0].value}
        value={data?.op}
        options={blockEventSingleOperatorOptions}
        onChange={(value) => {
          onChange?.(EBlockEventSingleChangeType.BLOCK_EVENT_SINGLE_OPERATOR, value);
        }}
        dropdownStyle={{
          minWidth: 'fit-content',
        }}
      />
      <AutoCompleteInput
        disabled={mode === EPanelOpenMethod.VIEW}
        loading={isTagValueLoading}
        placeholder="Type or select..."
        style={{ flex: '1 0 auto' }}
        value={blockRuleValue}
        options={blockRuleValueOptions}
        onChange={(value) => {
          onChange?.(EBlockEventSingleChangeType.BLOCK_EVENT_SINGLE_VALUE, value);
        }}
      />
    </>
  );
};

export default BlockRuleKeyValueBuilder;
